import TramiteFicha from './TramiteFicha';

const TramitesFichas = ({
  tramites,
  loading,
  handleClickFinalizar,
}) => {

  return (
    <div className="mt-4 space-y-3 px-3 pb-6">
      {!loading && tramites && tramites.map(t => (
        <TramiteFicha key={`tramite-${t.id}`}
          tramite={t}
          handleClickFinalizar={handleClickFinalizar}
        />
      ))}
    </div>
  );
}

export default TramitesFichas;